import { useWatch } from "react-hook-form";

/**
 * Los campos que NO cuentan como "haber escrito algo".
 *
 * El icono y el tema son presentación: nacen vacíos, se eligen en un
 * desplegable y por sí solos no llegan a la ficha —el bloque no viaja si
 * no tiene contenido de verdad—. Si contaran, elegir "oscuro" y cerrar
 * dejaría el bloque anunciado como escrito cuando en el envío no va nada.
 */
const PRESENTATION_KEYS = new Set(["icon", "theme"]);

/** ¿Queda algún texto —a cualquier profundidad— dentro de esto? */
function hasText(value: unknown): boolean {
  if (typeof value === "string") return value.trim() !== "";
  if (Array.isArray(value)) return value.some(hasText);
  if (value && typeof value === "object") {
    return Object.entries(value).some(
      ([key, nested]) => !PRESENTATION_KEYS.has(key) && hasText(nested),
    );
  }
  return false;
}

/**
 * Si un bloque editorial tiene algo escrito.
 *
 * Sirve para dos cosas a la vez: decidir si el bloque nace desplegado
 * —lo escrito se ve sin buscarlo— y pintar su estado en el encabezado
 * sin tener que abrirlo.
 */
export function useBlockFilled(name: string): boolean {
  const value = useWatch({ name });
  return hasText(value);
}
